<template>
<div>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <SideBar />
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">Lost Item</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
                <!-- Filter Part -->
                <div id="filterPart" class="card" >
                  <div class="row">
                    <div class="container" style="display : flex;">
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Company Name</span>
                        <input type="text" class="form-control" name="search_company_name" v-model="searchCompanyName" placeholder="Company">
                      </div>
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Product Name</span>
                        <input type="text" class="form-control" name="search_product_name" v-model="searchProductName" placeholder="Product Name">
                      </div>
                      <!--  -->
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Order ID / Ticket No</span>
                        <input type="text" class="form-control" name="search_order_id" v-model="searchOrderCode" placeholder="Order Id / Ticket No">
                      </div>
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Status</span>
                        <multiselect v-model="searchStatus" :options="lostItemStatusOptions" label="statusName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="statusName" :multiple="false" :close-on-select="true" default></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3" >
                    <div class="container-fluid">
                      <div class="col" style="display : flex; justify-content: flex-end;">
                        <div class="mr-3" style="width: 100px;">
                          <button type="submit" style="width: 100%;" class="btn btn-primary mr-2" @click="searchData">
                            Search
                          </button>
                        </div>
                        <div style="width: 100px;">
                          <button type="button" style="width: 100%;" class="btn btn-outline-secondary" @click="resetFilter">
                            Reset
                          </button>
                        </div>
                      </div>   
                    </div>
                  </div>
                </div>
                <!-- ENF OF FILTER PART -->
              <div class='row mt-3 mb-1'>
                  <div class="col-12" :style="`display : flex;`">
                    <button 
                      class="btn btn-outline-secondary" 
                      data-toggle="tooltip" 
                      data-placement="bottom" 
                      title="Download Data"
                      @click="downloadData"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                          d="M6.99999 10.1281C6.88333 10.1281 6.77395 10.11 6.67187 10.0739C6.56979 10.0377 6.47499 9.97558 6.3875 9.8875L3.2375 6.7375C3.0625 6.5625 2.9785 6.35833 2.9855 6.125C2.9925 5.89167 3.0765 5.6875 3.2375 5.5125C3.4125 5.3375 3.62046 5.2465 3.86137 5.2395C4.10229 5.2325 4.30995 5.31621 4.48437 5.49063L6.125 7.13125V0.875003C6.125 0.627086 6.20899 0.41942 6.377 0.252003C6.54499 0.0845864 6.75266 0.00058635 6.99999 3.01724e-06C7.24733 -0.000580316 7.45529 0.0834198 7.62387 0.252003C7.79245 0.420586 7.87616 0.628253 7.87499 0.875003V7.13125L9.51562 5.49063C9.69062 5.31563 9.89858 5.23163 10.1395 5.23863C10.3804 5.24563 10.5881 5.33692 10.7625 5.5125C10.9229 5.6875 11.0069 5.89167 11.0145 6.125C11.0221 6.35833 10.9381 6.5625 10.7625 6.7375L7.61249 9.8875C7.52499 9.975 7.4302 10.0371 7.32812 10.0739C7.22604 10.1106 7.11666 10.1287 6.99999 10.1281ZM1.75 14C1.26875 14 0.856916 13.8288 0.514499 13.4864C0.172083 13.144 0.000583333 12.7318 0 12.25V10.5C0 10.2521 0.084 10.0444 0.252 9.877C0.42 9.70958 0.627666 9.62558 0.874999 9.625C1.12233 9.62442 1.33029 9.70842 1.49887 9.877C1.66746 10.0456 1.75117 10.2533 1.75 10.5V12.25H12.25V10.5C12.25 10.2521 12.334 10.0444 12.502 9.877C12.67 9.70958 12.8777 9.62558 13.125 9.625C13.3723 9.62442 13.5803 9.70842 13.7489 9.877C13.9174 10.0456 14.0012 10.2533 14 10.5V12.25C14 12.7312 13.8288 13.1434 13.4864 13.4864C13.1439 13.8294 12.7318 14.0006 12.25 14H1.75Z" 
                          fill="#2E3646"/>
                      </svg>
                      <span style="color : #2E3646">Download CSV </span>
                    </button>
                  </div>
              </div>

              <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
                <thead class="">
                  <tr>
                    <th class="table-field-name">Company Name</th>
                    <th class="table-field-name">Product Name</th>
                    <th class="table-field-name" style="max-width : 11em;">Qty</th>
                    <th class="table-field-name">Order ID / Ticket No.</th>
                    <th class="table-field-name">Status</th>
                  </tr>
                </thead>
                <tbody v-if="loadingTable == true">
                  <tr>
                    <td colspan="5" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
                  </tr>
                </tbody>
                <tbody v-else-if="loadingTable == false && dataLostItem.length == 0">
                  <!-- <tr v-else-if="loadingTable == false && totalData == 0"> -->
                  <tr>
                    <td colspan="5" class="text-center">Data not available</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(data) in dataLostItem" :key="data.id">
                    <td class="text-left">
                      <router-link 
                        :to="{
                          path:'/partnership/lessee/detail/' + data.companyId, 
                          query: {
                            companyStatus : data.companyStatus
                          }
                        }"
                      >
                        {{ data.companyName }}
                      </router-link>
                    </td>
                    <td class="text-left">{{data.itemName}}</td>
                    <td>{{data.qty}}</td>
                    <td class="text-left">
                      <router-link
                        v-if="!data.ticketId"
                        :to="{
                          path: '/order/detail/' + data.orderId,
                          query: {
                            orderCode: data.orderCode,
                            companyIdDetail: data.companyId,
                          },
                        }"
                      >
                          {{ data.orderCode }}
                      </router-link>
                      <router-link
                        v-else
                        :to="{path: '/resolution/detail/' + data.ticketId,}"
                      >
                          {{ data.orderCode }}
                      </router-link>
                    </td>
                    <td class="text-center">
                      <div class="status-column" v-if="editLostItem">
                        <div class="dropdown">
                          <button 
                            :class="`custom-status-btn status-${data.status} dropdown-toggle`"
                            type="button" 
                            :id="'dropdownStatus' + data.orderCode"
                            data-toggle="dropdown" 
                            aria-haspopup="true" 
                            aria-expanded="false">
                            {{data.status}}
                          </button>
                          <div class="dropdown-menu" >
                            <a href="#" class="dropdown-item" v-for="stats in filteredStatusList(data.status)" :key="data.orderCode+'-'+stats" @click="openModalUpdate(data,stats)" >
                              <span :class="`status-indicator status-${stats}`"></span>
                              {{stats}}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="status-column" v-else>
                        <div class="dropdown">
                          <button 
                            :class="`custom-status-btn-inactive status-${data.status}`"
                            type="button" 
                            :id="'dropdownStatus' + data.orderCode"
                            >
                            {{data.status}}
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div id="wrapperr">
                <div id="c1" style="display: inline-flex;">
                  <div style="margin-right: 10px;">
                    <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData()">
                      <option value="10">10</option>
                      <option value="40">40</option>
                      <option value="80">80</option>
                    </select>
                  </div>
                  <div class="alignLeft total-data">
                    Total Data {{ totalData }}
                  </div>
                </div>
                <div id="c2">
                  <div class="pagination p8 alignRight">
                    <ul>
                      <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1">
                        <li>
                          {{'<'}}</li> </a> <a class="page">
                        <li>{{ currentPage }} of {{ totalPage }} page</li>
                      </a>
                      <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage">
                        <li>></li>
                      </a>
                    </ul>
                  </div>
                </div>
              </div>
              ​
            </div>
          </div>
        </div>
        <ModalEditLostStatusConfirm :newStatus="selectedStatus" :updateStatus="updateStatus"/>
      </div>
    </div>
    <!-- /#page-content-wrapper -->

  </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Swal from 'sweetalert2';
import SideBar from "../SideBar";
import { Money } from "v-money";
import ModalEditLostStatusConfirm from "./CustomComponent/ModalEditLostStatusConfirm.vue";

export default {
  name: "lostItemPage",
  components: {
    SideBar,
    Multiselect,
    Money,
    ModalEditLostStatusConfirm,
  },
  data() {
    return {
      loadingTable: false,
      loadingButtonDownload : false,
      lostItemStatusOptions: [
        {
          statusName: "All",
        },
        {
          statusName: "Unpaid",
        },
        {
          statusName: "Paid",
        },
        {
          statusName: "Ignored",
        },
      ],
      searchOrderCode : '',
      searchCompanyName :'',
      searchProductName:'',
      searchStatus: {
          statusName : 'All'
        },
      admin: "",
      permission: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      itemPerPage: 10,
      dataLostItem: [],
      token: localStorage.getItem("jwt"),
      password: "",
      showErrorUnit : false,
      errorUnitList : [],
      viewLostItem : false,
      editLostItem : false,
      lostItemStatusList : ['unpaid','paid','ignored'],
      selectedStatus : '',
      editedData : null,
    };
  },
  methods: {
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadData() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.loadingButtonDownload = true
      this.$http.post(
        process.env.DOWNLOAD_LOST_ITEM_LIST, 
        {
          companyName: this.searchCompanyName,
          productName: this.searchProductName,
          orderId: this.searchOrderCode,
          status: this.searchStatus.statusName == 'All' ? '' : this.searchStatus.statusName.toLowerCase(),
        },
        { 
          timeout: 20 * 6000,
          responseType: "arraybuffer",
          headers: { 'Asani-Token': localStorage.getItem('jwt') } 
        })
        .then(res => {
          const responseType = res.config.responseType
    
          let responseStatus = ''
          let responseMessage = ''
          if (responseType && responseType == 'arraybuffer') {
            const responseBufferJSON = Buffer.from(res.data).toJSON();
            if (responseBufferJSON.data[0] == 123) {
              let responseString = ''
              responseBufferJSON.data.forEach(item => {
                responseString = responseString + String.fromCharCode(item)
              })
              const response = JSON.parse(responseString)
              responseStatus = response.status
              responseMessage = response.message
            } else {
              const fileName = `lost_item_${this.searchStatus.statusName}.csv`;
              this.forceFileDownload(res, fileName);
            }
            swalWithBootstrapButtons.fire({
              title: "Success",
              text: `Lost Items list has been successfully downloaded as a CSV.`,
              icon: "success",
            }).then(result => {
              this.loadingButtonDownload = false
            })
          }
          if(responseStatus == 400) {  
           swal("Sorry", responseMessage , "error", {
              button: "Close"
              });
              this.loadingButtonDownload = false
          } 
        })
        .catch(error => {
          this.loadingButtonDownload = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        })
    },
    filteredStatusList(currentStatus) {
      return this.lostItemStatusList.filter(stats => stats !== currentStatus);
    },
    openModalUpdate(data, status) {
      this.editedData = data;
      this.selectedStatus = status;
      $('#modalEditLostStatusConfirm').modal('show');
    },
    updateStatus() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.$http
      .post(
        process.env.UPDATE_LOST_ITEM_STATUS, {
          odaIds: this.editedData.odaIds,
          status: this.selectedStatus,    
        }, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        }
      )
      .then((response) => {
          if(response.data.status == 200) {
            swalWithBootstrapButtons.fire({
              title: "Success",
              text: `${response.data.message}`,
              icon: "success",
            }).then(result => {
              this.selectedStatus = ''
              this.editedData = null
              $('#modalEditLostStatusConfirm').modal('hide');
              this.getData()
            }) 
          } else {
            swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${response.data.message}`,
              icon: "error",
            }).then(result => {
              this.selectedStatus = ''
              this.editedData = null
              $('#modalEditLostStatusConfirm').modal('hide');
            })
          }
        })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        });
      });
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      if(!this.permission.includes('2.7')) {
        this.$router.push('/')
      } else {
        for (var i = 0; i < this.permission.length; i++) {
          if(this.permission[i] == '2.7') {
            this.viewLostItem = true
          }
          if(this.permission[i] == '2.8') {
            this.editLostItem = true
          }
        
          if (this.viewLostItem == false) {
            
          }
        }
      }
      
    },

    sendLog(w, x) {
      // var today = new Date();
      // var month = today.getMonth()+1
      // if (month < 10) {
      //     month = '0'+month
      // }
      // var dateDay = today.getDate()
      // if (dateDay < 10) {
      //     dateDay = '0'+dateDay
      // }
      // var hours = today.getHours()
      // if (hours < 10) {
      //     hours = '0'+hours
      // }
      // var minutes = today.getMinutes()
      // if (minutes < 10) {
      //     minutes = '0'+minutes
      // }
      // var second = today.getSeconds()
      // if (second < 10) {
      //     second = '0'+second
      // }
      // var date = today.getFullYear()+'-'+month+'-'+dateDay;
      // var time = hours + ":" + minutes + ":" + second;
      // var dateTime = date+' '+time;
      // var admin = this.admin
      // var command = 'add-logs'
      // // var productName = this.productNameChoose
      // this.$http.post(process.env.LOG_URL+"/company/"+x,{
      //     codeLogs: w,
      //     params: [],
      // },{
      //     headers: {'Asani-Token':localStorage.getItem('jwt')}
      // })
      // .then(response => {
      // })
      // .catch(error => {
      //     console.log(error)
      // })
    },
    resetFilter() {
      this.searchCCompanyName= '';
      this.searchProductName= '';
      this.searchOrderCode = '';
      this.searchStatus= {statusName : 'All'};
      
      this.$router.push({
        path: "/lost-item",
        query: {
          page: 1,
          itemPerPage: 10,
          companyName: this.searchCompanyName,
          productName: this.searchProductName,
          orderId: this.searchOrderCode,
          status: this.searchStatus.statusName,
        },
      });
    },
    searchData() {
      this.$router.push({
        path: "/lost-item",
        query: {
          page: 1,
          itemPerPage: this.itemPerPage,
          companyName: this.searchCompanyName,
          productName: this.searchProductName,
          orderId: this.searchOrderCode,
          status: this.searchStatus.statusName,
        },
      });
    },
    toDataPage(pagePost) {
      this.$router.push({
        path: "/lost-item",
        query: {
          page: pagePost,
          itemPerPage: this.itemPerPage,
          companyName: this.searchCompanyName,
          productName: this.searchProductName,
          orderId: this.searchOrderCode,
          status: this.searchStatus.statusName,
        },
      });
      // location.reload();
      // this.getData();
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModal(modalName) {
      $("#modal" + modalName).modal("show");
    },
    getData() {
      this.loadingTable = true;
      this.searchCompanyName = this.$route.query.companyName;
      this.searchProductName = this.$route.query.productName;
      this.searchOrderCode = this.$route.query.orderId;
      this.searchStatus = this.lostItemStatusOptions.find(item => item.statusName == this.$route.query.status);
      this.itemPerPage = parseInt(this.$route.query.itemPerPage);
      this.currentPage = parseInt(this.$route.query.page);

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      const newStatus = this.searchStatus.statusName == 'All' ? '' : this.searchStatus.statusName

      this.$http
      .post(
          process.env.SEARCH_LOST_ITEM, {
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
            companyName: this.searchCompanyName,
            productName: this.searchProductName,
            orderId: this.searchOrderCode,
            status: newStatus.toLowerCase(),
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
      .then((response) => {
        if(response.status == 200 || response.data.status == 200) {
          console.log(response.data.data.data)
          this.dataLostItem = response.data.data.data ? response.data.data.data : [];
          this.totalPage = response.data.data.totalPage;
          this.totalData = response.data.data.totalData;
          this.currentPage = response.data.data.currentPage;
        } else {
          swalWithBootstrapButtons.fire({
            icon: "error",
            title: "Failed",
            text: response.data.message,
          }).then((result) => {
            if(result.isConfirmed) {
              
            } 
            this.dataLostItem = []
            this.loadingTable = false;
          });
        }
        this.loadingTable = false;
          
        })
      .catch(error => {
        swalWithBootstrapButtons.fire({
          icon: "error",
          title: "Failed",
          text: error,
        }).then((result) => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        });
      });
    },

  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem('roles'))
    this.admin = localStorage.getItem("admin_name");
    this.cekLogin();
    this.cekPermission();
    this.getData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.custom-status-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  min-width: 100px;
  justify-content: space-between;
}

.custom-status-btn-inactive{
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  cursor: pointer;

  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  min-width: 100px;
  justify-content: space-between;
}

.custom-status-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.custom-status-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.3);
}

.custom-status-btn.status-unpaid {
  background-color: #6c7a8a;
}

.custom-status-btn.status-paid {
  background-color: #28a745;
}

.custom-status-btn.status-ignored {
  background-color: #dc3545;
}
.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
.status-unpaid {
  background-color: #6c757d;
}
    
.status-paid {
  background-color: #28a745;
}
    
.status-ignored {
  background-color: #dc3545;
}

.dropdown-menu {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  min-width: 150px;
}

.dropdown-item {
  cursor: pointer;
}
    
.dropdown-item:hover {
  background-color: #f8f9fa;
}

#filterPart {
  padding: 1rem;
}
.filter-field-name {
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.1%;
  vertical-align: middle;
}
.table-field-name {
  font-family: Inter;
  font-weight: 700;
  font-style: Semi Bold;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.1%;
  vertical-align: middle;
}
tbody tr td {
  font-size: 0.9em;;
}
td {
  text-align: center;
}
th {
  text-align: center;
  vertical-align: middle;
}
.btn-view-cart .badge {
  margin-top : 2px;
  position: absolute;
  top: -10px;
  padding: 5px 7px;
  border-radius: 50%;
  background: rgba(247, 143, 48, 1);
  color: white;
  font-weight: 700;
}
.btn-view-cart:hover {
  background-color: rgba(214, 234, 253, 1);
}
.item-paid-badge {
  display: inline-block;
  padding: 0.25em 0.8em;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: rgba(99, 166, 78, 1);
}
.item-unpaid-badge {
  display: inline-block;
  padding: 0.25em 0.8em;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: rgba(76, 84, 100, 1);
}
.btn-add-cart{
  border-radius: 0.6rem;
}
.btn-add-cart:hover {
  background-color: rgba(214, 234, 253, 1);
}
.btn-remove-cart{
  border-radius: 0.6rem;
}
.btn-remove-cart:hover {
  background-color: #FEF4EA;
}
.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/LostItemPage.vue